import React, {Component} from 'react'
import cx from 'classnames'
import { isMobile } from 'react-device-detect'

import Link from '../../components/site/typography/Link'
import ButtonLink from '../../components/site/Button/ButtonLink'
import Picture from '../../components/Picture'

class MenuItem extends Component {
    constructor(props) {
        super(props)

        this.handleClickOutside = this.handleClickOutside.bind(this)
        this.setWrapperRef = this.setWrapperRef.bind(this)

        this.state = {
            isOpen: false,
        }
    }

    static defaultProps = {
        color: 'linkLight',
        href: '.',
    }

    setWrapperRef(node) {
        this.wrapperRef = node
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.toggleDropdown()
        }
    }

    toggleDropdown(e) {
        e && e.preventDefault()

        if (!isMobile) {
            if (this.state.isOpen) {
                document.removeEventListener('mousedown', this.handleClickOutside)
                document.removeEventListener('mouseover', this.handleClickOutside)
            } else {
                document.addEventListener('mousedown', this.handleClickOutside)
                document.addEventListener('mouseover', this.handleClickOutside)
            }
        }

        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const type = this.props.type
        return(
            <li className={cx('nav-item', this.props.className, this.props.subItems && 'show-dropdown', this.props.newSubItems && 'show-dropdown',this.state.isOpen && 'opened')} ref={this.setWrapperRef}>
                {type === 'button' ?
                    <ButtonLink className='menu-cta-button'
                        color={this.props.color}
                        model={this.props.model || 'outline'}
                        radius='half-rounded'
                        size='small'
                        href={this.props.href}
                        target={this.props.target}
                        title={this.props.title}
                        onClick={this.props.onClick}
                        shake={this.props.shake}
                    >
                        {this.props.children}
                    </ButtonLink>
                    :
                    <Link className={`nav-link${type === 'mobile' ? '-mobile' : ''}`}
                        color={this.props.color}
                        href={this.props.href}
                        title={this.props.title}
                        model={this.props.model || 'hover-underline'}
                        target={this.props.target}
                        onClick={this.props.onClick}
                        {...(this.props.subItems && {onClick: (e) => this.toggleDropdown(e), ...(!isMobile && {onMouseOver: (e) => this.toggleDropdown(e)})})}
                        {...(this.props.newSubItems && {onClick: (e) => this.toggleDropdown(e), ...(!isMobile && {onMouseOver: (e) => this.toggleDropdown(e)})})}
                    >
                        {this.props.children}
                    </Link>
                }
                {this.props.subItems && <div className='dropdown-menu-mercos'>
                    <ul className='list-unstyled'>
                        {this.props.subItems.map(function(item, index) {
                            return <li key={`menu-subitem-${index}`}>
                                <Link model='hover-underline'
                                    href={item.href}
                                    title={item.title}
                                    target={item.target}>
                                    {item.content}
                                </Link>
                            </li>
                        })}
                    </ul>
                </div>}
                {this.props.newSubItems && <div className='new-dropdown-menu-mercos'>
                    <ul className='list-unstyled'>
                        {this.props.newSubItems.map(function(item, index) {
                            return <li key={`menu-subitem-${index}`}>
                                <Link model='hover-underline'
                                      href={item.href}
                                      title={item.title}
                                      color='linkBlack'
                                      target={item.target}>
                                    {item.url && <Picture alt={item.title} src={item.url} />}
                                    {item.content}
                                </Link>
                            </li>
                        })}
                    </ul>
                </div>}
                {this.props.newSubItemsv2 && <div className='new-dropdown-menu-mercos'>
                    <ul className='list-unstyled'>
                        {this.props.newSubItemsv2.map(function(item, index) {
                            return <li key={`menu-subitem-${index}`}>
                                <Link model='hover-underline'
                                      href={item.href}
                                      title={item.title}
                                      color='linkBlack'
                                      target={item.target}>
                                    {item.url && <Picture alt={item.title} src={item.url} />}
                                    {item.content}
                                </Link>
                            </li>
                        })}
                    </ul>
                </div>}
            </li>
        )
    }
}

export default MenuItem



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/MenuItem.jsx